import React, { useState } from "react";
import { SubscriptionEstimationApi, SubscriptionEstimationFeatureTranslation } from "../../../api/types";
import SubscriptionBasedRestrictionModal from "../Modal/SubscriptionBasedRestrictionModal";

export interface SubscriptionBasedModalConfigProps {
	featureName: string;
	featureId: string;
	limit?: number;
	property: number | string | boolean;
	resource?: string;
	featureTranslations: SubscriptionEstimationFeatureTranslation[];
	accountsUrl: string;
	companyId: string;
	getSubscriptionsEstimate: (
		featureId: string,
		params?: Record<string, any>,
		options?: Record<string, any>
	) => Promise<SubscriptionEstimationApi>;
	onHide?: () => void;
}

const useSubscriptionBasedRestriction = () => {
	const [showRestrictionModal, setShowRestrictionModal] = useState(false);
	const [modalConfig, setModalConfig] = useState<SubscriptionBasedModalConfigProps | undefined>();

	const handleShowSubscriptionBasedRestrictionModal = () => setShowRestrictionModal(true);

	const handleSetSubscriptionBasedRestrictionModalConfig = (config: SubscriptionBasedModalConfigProps) =>
		setModalConfig(config);

	const handleHide = () => {
		setShowRestrictionModal(false);
		setModalConfig(undefined);
		if (modalConfig?.onHide) {
			modalConfig.onHide();
		}
	};

	const renderSubscriptionBasedRestrictionModal = () => {
		if (showRestrictionModal && modalConfig) {
			return (
				<SubscriptionBasedRestrictionModal
					show={showRestrictionModal}
					onHide={handleHide}
					featureId={modalConfig.featureId}
					limit={modalConfig.limit}
					name={modalConfig.featureName}
					property={modalConfig.property}
					resource={modalConfig.resource}
					featureTranslations={modalConfig.featureTranslations}
					companyId={modalConfig.companyId}
					accountsUrl={modalConfig.accountsUrl}
					getSubscriptionsEstimate={modalConfig.getSubscriptionsEstimate}
				/>
			);
		}
	};

	return {
		handleShowSubscriptionBasedRestrictionModal,
		renderSubscriptionBasedRestrictionModal,
		handleSetSubscriptionBasedRestrictionModalConfig,
	};
};

export default useSubscriptionBasedRestriction;
